export const newsStateName = "news";

export const newsInitialState = {
  news: { list: [], loading: false },
};
